import React, { useEffect, useContext, useState } from "react";
import Grid from "@mui/material/Grid";
import { SelectChangeEvent } from "@mui/material/Select";
import CountGridTile from "./CountGridTile";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import ThumbDownAltTwoToneIcon from "@mui/icons-material/ThumbDownAltTwoTone";
import ReplayIcon from "@mui/icons-material/Replay";
import HelpIcon from "@mui/icons-material/Help";

import { Chip, Paper, Slider, Stack, Tooltip } from "@mui/material";
import { appLogger, Http } from "../../../src/utils";
import { getDateString, getDateTimeRange } from "../../utils/data";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { Box, Rating, Typography, Divider } from "@mui/material";
import TextField from "@mui/material/TextField";
import RatingChart from "../feedback/rating";
import { useLocation, useNavigate } from "react-router-dom";
import DashBugReportchart from "./BugReportChart";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import ProductVersionDropdown from "../common/ProductVersionDropdown";
import DailyCountchart from "./DailyCountChart";
import TopTenChartCommentors from "./topTenChartCommentors";
import NoProductMessage from "../../utils/common/NoProductMessage";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_SUPERADMIN,
  ROLE_USER_MANAGER,
  FeedbackMetricsData,
  FEEDBACK_TYPE_FEEDBACK,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_BUG_REPORT,
} from "../../model";
import {
  enableBugReport,
  enableChatbot,
  enableFeatureRequest,
  enableFeedback,
  enableInsights,
} from "../../utils/config";
import Joyride, {
  CallBackProps,
  STATUS,
  Step,
  StoreHelpers,
  ACTIONS,
} from "react-joyride";
function DashboardContent(props: any) {
  const location = useLocation();
  const navigate = useNavigate();
  appLogger.info({
    infoObj: {
      method: "DashboardContent",
      component: "dashboard",
      fileName: "index.tsx",
      location: location,
    },
  });
  const currDate = new Date();
  const stDate = new Date(currDate);
  stDate.setHours(0, 0, 0, 0);
  currDate.setHours(23, 59, 59, 999);
  let stDateTimestamp: any = "";
  let currDateTimestamp: any = "";

  stDate.setMonth(currDate.getMonth() - 1);
  stDate.setDate(stDate.getDate() + 1);
  if (stDate && currDate) {
    stDateTimestamp = stDate.getTime();
    currDateTimestamp = currDate.getTime();
  }
  const [product, setProduct] = React.useState("");
  const [selectedProduct, setSelectedProduct] = React.useState<any>();
  const [productResponse, setProductResponse] = React.useState([] as any);
  const [version, setVersion] = React.useState("");
  // const [userData, setUserData] = React.useState([] as any);
  // const [startDateValue, setStartDateValue] = React.useState(null as any);
  // const [endDateValue, setEndDateValue] = React.useState(null as any);
  const [startDateValue, setStartDateValue] = React.useState(stDateTimestamp);
  const [endDateValue, setEndDateValue] = React.useState(currDateTimestamp);
  const [insightsData, setInsightsData] = React.useState([] as any);
  const [insightsBugData, setInsightsBugData] = React.useState([] as any);
  const [insightsFeatureReqData, setInsightsFeatureReqData] = React.useState(
    [] as any
  );
  const [PositiveInsightData, setPositiveInsightData] = React.useState(true);
  const [NegativeInsightData, setNegativeInsightData] = React.useState(true);
  const [NeutralInsightData, setNeutralInsightData] = React.useState(true);
  const [selectedProVerData, setselectedProVerData] = React.useState([] as any);
  const [chartShow, setChartShow] = React.useState(false);
  const [ratingChartData, setRatingChartData] = React.useState({
    avg: 0,
    total: 0,
    data: { "5": 0, "4": 0, "3": 0, "2": 0, "1": 0 },
  });
  const [bugReportChartData, setBugReportChartData] = React.useState({
    avg: 0,
    total: 0,
    data: {
      "": 0,
    },
  });
  const [FeatureReqChartData, setFeatureReqChartData] = React.useState({
    avg: 0,
    total: 0,
    data: {
      "": 0,
    },
  });

  const [dailyCountBugChartData, setDailyCountBugChartData] = React.useState({
    avg: 0,
    total: 0,
    data: {
      "": 0,
    },
  });
  const [dailyCountFeedbackChartData, setDailyCountFeedbackChartData] =
    React.useState({
      avg: 0,
      total: 0,
      data: {
        "": 0,
      },
    });
  const [dailyCountFeatureReqChartData, setDailyCountFeatureReqChartData] =
    React.useState({
      avg: 0,
      total: 0,
      data: {
        "": 0,
      },
    });

  const [UserCountsFBData, setUserCountsFBData] = React.useState({
    avg: 0,
    total: 0,
    data: {
      "": 0,
    },
  });
  const [UserCountsBugsData, setUserCountsBugsData] = React.useState({
    avg: 0,
    total: 0,
    data: {
      "": 0,
    },
  });
  const [metricData, setMetricData] = React.useState<
    FeedbackMetricsData | undefined
  >(undefined);
  const [UserCountsFeatureReqData, setUserCountsFeatureReqData] =
    React.useState({});
  const [isLoading, setIsloading] = React.useState(true);
  const [proVerUrl, setproVerUrl] = React.useState("");
  const [selectedProVerDataType, setselectedProVerDataType] =
    React.useState("confirm");
  const [run, setRun] = useState(false);

  const {
    userInfo,
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    contextProVersion,
    setcontextProVersion,
    contextRedirectProdPage,
    enabledFeatures,
    setBasicDetailAccordianContext,
    setGenSettingsAccordianContext,
    setFbSettingsAccordianContext,
    setBugSettingsAccordianContext,
    setFreqSettingsAccordianContext,
    setEmailSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
    setWidgAppSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
    setQRSettingsAccordianContext,
  } = useContext(UserContext) as UserLoginInfo;

  // const currDate = new Date();
  // const stDate = new Date();
  // const currDateVal = currDate.setHours(23, 59, 59, 999);
  // stDate.setDate(currDate.getDate() - 7);

  const getUTCDate = (dateValue: any) => {
    const utcDate = new Date(parseInt(dateValue, 10));
    return utcDate;
  };

  useEffect(() => {
    setFilterDate({
      startDate: startDateValue,
      endDate: endDateValue,
    });
  }, [endDateValue]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "dashboard",
        fileName: "index.tsx",
        filterDate: filterDate,
      },
    });
  }, [filterDate]);

  // const changeStartDateValue = (dateValue: any) => {
  //   let utcDate = null;
  //   if (dateValue < 0) {
  //     dateValue = dateValue * -1;
  //   }

  //   if (dateValue != null) {
  //     utcDate = dateValue != null && Date.parse(dateValue.toString());
  //   }

  //   const date = new Date(dateValue.target.value);

  //   const timestamp = date.getTime();
  //   setStartDateValue(timestamp);
  //   appLogger.info({
  //     infoObj: {
  //       method: "changeStartDateValue",
  //       component: "dashboard",
  //       fileName: "index.tsx",
  //       timestamp: timestamp,
  //     },
  //   });
  //   if (timestamp > endDateValue) {
  //     setEndDateValue(null);
  //   }
  // };
  // const changeEndDateValue = (dateValue: any) => {
  //   let utcDate = null;
  //   if (dateValue < 0) {
  //     dateValue = dateValue * -1;
  //   }

  //   if (dateValue != null) {
  //     utcDate = dateValue != null && Date.parse(dateValue.toString());
  //   }

  //   const date = new Date(dateValue.target.value);

  //   const timestamp = date.getTime();
  //   appLogger.info({
  //     infoObj: {
  //       method: "changeEndDateValue",
  //       component: "dashboard",
  //       fileName: "index.tsx",
  //       timestamp: timestamp,
  //     },
  //   });

  //   setEndDateValue(timestamp);
  // };
  const changeStartDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(0, 0, 0, 0);
    const timestamp = dt.getTime();
    setStartDateValue(timestamp);
    appLogger.info({
      infoObj: {
        method: "changeStartDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
    if (timestamp > endDateValue) {
      setEndDateValue(null);
    }
  };

  const changeEndDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(23, 59, 59, 999);
    const timestamp = dt.getTime();
    setEndDateValue(timestamp);

    appLogger.info({
      infoObj: {
        method: "changeEndDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      productResponse.length < 1
    ) {
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            response &&
              response.productNameList &&
              response.productNameList.length > 0 &&
              response.productNameList.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                productResponse: response,
              },
            });
            setProductResponse(response.productNameList);
            const extProd = response.productNameList.filter(
              (e: any) =>
                e.id == ProVersion.product && e.version == ProVersion.version
            );
            if (extProd.length > 0) {
              setProduct(response.productNameList[0].id);
              setVersion(response.productNameList[0].version);
              setSelectedProduct(response.productNameList[0]);

              setProVersion({
                product: response.productNameList[0].id,
                version: response.productNameList[0].version,
              });
            } else {
              setProduct(ProVersion.product || response.productNameList[0].id);
              setVersion(
                ProVersion.version || response.productNameList[0].version
              );
              setSelectedProduct(response.productNameList[0]);

              setProVersion({
                product: ProVersion.product || response.productNameList[0].id,
                version:
                  ProVersion.version || response.productNameList[0].version,
              });
            }

            let tempurl = "";
            if (
              Array.isArray(contextProVersion) &&
              contextProVersion.length > 0
            ) {
              const extProd = [];
              for (let i = 0; i < response.productNameList.length; i++) {
                for (let j = 0; j < contextProVersion.length; j++) {
                  if (
                    response.productNameList[i].id ==
                      contextProVersion[j].value &&
                    response.productNameList[i].version ==
                      contextProVersion[j].version
                  ) {
                    extProd.push(contextProVersion[j]);
                  }
                }
              }
              setcontextProVersion(extProd);
              setselectedProVerData(extProd);
              extProd.map((data: any) => {
                tempurl += `&prodId=${data.value}&prodVersion=${data.version}`;
              });
              setproVerUrl(tempurl);
            } else {
              setselectedProVerData([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                },
              ]);
              setcontextProVersion([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                  proversion:
                    response.productNameList[0].name +
                    response.productNameList[0].version,
                },
              ]);
              tempurl = `&prodId=${response.productNameList[0].id}&prodVersion=${response.productNameList[0].version}`;
              setproVerUrl(tempurl);
            }
            setIsloading(false);
          } else {
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                userInfo: userInfo,
              },
            });
            setIsloading(false);
            if (
              !contextRedirectProdPage &&
              (userInfo?.userDetails?.userRole == ROLE_USER_SUPERADMIN ||
                userInfo?.userDetails?.userRole == ROLE_USER_MANAGER ||
                userInfo?.userDetails?.userRole == ROLE_USER_ADMIN)
            ) {
              // openGuidedtour();
              // navigate("/add-product");
              setBasicDetailAccordianContext(true);
              setGenSettingsAccordianContext(false);
              setFbSettingsAccordianContext(false);
              setBugSettingsAccordianContext(false);
              setFreqSettingsAccordianContext(false);
              setEmailSettingsAccordianContext(false);
              setExttrackingSettingsAccordianContext(false);
              setWidgAppSettingsAccordianContext(false);
              setWidgIntgSettingsAccordianContext(false);
              setQRSettingsAccordianContext(false);
            }
            // props.snackbarShowMessage("No products created in your organization. Create a product first", "error");
            // setTimeout(() => {
            //   navigate("/add-product")
            // }, 2000);
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          setIsloading(false);
        });
    }
  }, [userInfo]);

  // const fetchUserData = () => {
  //   Http.get({
  //     url: `/api/v2/userFeedback/FEEDBACK?prodId=${product}&prodVersion=${version}`,
  //     state: userInfo,
  //   })
  //     .then((response: any) => {
  //       setIsloading(false);
  //       setUserData(response.Items);
  //       // setBugReportChartData(response.chartData);
  //     })
  //     .catch((error) => {
  //       setIsloading(false);
  //       props.snackbarShowMessage(error.message, "error");
  //     });
  // };

  const fetchInsightsData = () => {
    if (proVerUrl) {
      const datewiseFilter =
        startDateValue && endDateValue
          ? `&startDate=${startDateValue ? startDateValue : ""}&endDate=${
              endDateValue ? endDateValue : ""
            }`
          : "";
      Http.get({
        url: `/api/v2/chart/FEEDBACK?${proVerUrl}&xAxisData=Insights&count=10${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          setInsightsData(response.chartData);
          appLogger.info({
            infoObj: {
              method: "fetchInsightsData",
              component: "dashboard",
              fileName: "index.tsx",
              InsightsData: response.chartData,
            },
          });
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
          props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "fetchInsightsData",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    }
  };
  const fetchInsightsBugData = () => {
    if (proVerUrl) {
      const datewiseFilter =
        startDateValue && endDateValue
          ? `&startDate=${startDateValue ? startDateValue : ""}&endDate=${
              endDateValue ? endDateValue : ""
            }`
          : "";
      Http.get({
        url: `/api/v2/chart/BUG_REPORT?${proVerUrl}&xAxisData=Insights&count=10${datewiseFilter}&agent=FEEDBACK_AGENT`,
        state: userInfo,
      })
        .then((response: any) => {
          appLogger.info({
            infoObj: {
              method: "fetchInsightsBugData",
              component: "dashboard",
              fileName: "index.tsx",
              InsightsData: response.chartData,
            },
          });
          setInsightsBugData(response.chartData);
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
          props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "fetchInsightsBugData",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    }
  };
  const fetchInsightsFeatureReqData = () => {
    if (proVerUrl) {
      const datewiseFilter =
        startDateValue && endDateValue
          ? `&startDate=${startDateValue ? startDateValue : ""}&endDate=${
              endDateValue ? endDateValue : ""
            }`
          : "";
      Http.get({
        url: `/api/v2/chart/FEATURE_REQUEST?${proVerUrl}&xAxisData=Insights&count=10${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          appLogger.info({
            infoObj: {
              method: "fetchInsightsFeatureReqData",
              component: "dashboard",
              fileName: "index.tsx",
              InsightsData: response.chartData,
            },
          });
          setInsightsFeatureReqData(response.chartData);
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
          props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "fetchInsightsFeatureReqData",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    }
  };

  // useEffect(() => {
  //   if (product && version) {
  //     // fetchUserData();
  //     fetchInsightsData();
  //     fetchInsightsBugData();
  //   }
  // }, [product, version]);
  const fetchMetricCount = () => {
    const datewiseFilter = `&startDate=${
      startDateValue ? startDateValue : ""
    }&endDate=${endDateValue ? endDateValue : ""}`;

    Http.get({
      url: `/api/v2/metric/AVERAGE?${proVerUrl}${datewiseFilter}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "fetchMetricCount",
            component: "dashboard",
            fileName: "index.tsx",
            InsightsData: response.metricData,
          },
        });
        setMetricData(response.metricData);
        //        overAllscore(response.metricData);
      })
      .catch((error) => {
        setIsloading(false);
        props.snackbarShowMessage(error.message, "error");
        appLogger.error({
          errObj: {
            method: "fetchMetricCount",
            component: "dashboard",
            fileName: "index.tsx",
            err: error,
          },
        });
      });
  };
  const fetchRatingChartData = () => {
    // let datewiseFilter = "";
    // if (startDateValue && endDateValue) {
    const datewiseFilter =
      startDateValue && endDateValue
        ? `&startDate=${startDateValue ? startDateValue : ""}&endDate=${
            endDateValue ? endDateValue : ""
          }`
        : "";
    // }
    Http.get({
      url: `/api/v2/chart/FEEDBACK?${proVerUrl}&xAxisData=Rating${datewiseFilter}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "fetchRatingChartData",
            component: "dashboard",
            fileName: "index.tsx",
            ratingChartData: response.chartData,
          },
        });
        setRatingChartData(response.chartData);
        setChartShow(true);

        if (datewiseFilter) {
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
        props.snackbarShowMessage(error.message, "error");
        appLogger.error({
          errObj: {
            method: "fetchRatingChartData",
            component: "dashboard",
            fileName: "index.tsx",
            err: error,
          },
        });
      });
  };

  const fetchBugReportChartData = () => {
    const datewiseFilter =
      startDateValue && endDateValue
        ? `&startDate=${startDateValue ? startDateValue : ""}&endDate=${
            endDateValue ? endDateValue : ""
          }`
        : "";

    Http.get({
      url: `/api/v2/chart/BUG_REPORT?${proVerUrl}&xAxisData=Severity${datewiseFilter}&agent=FEEDBACK_AGENT`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "fetchBugReportChartData",
            component: "dashboard",
            fileName: "index.tsx",
            ratingChartData: response.chartData,
          },
        });
        setBugReportChartData(response.chartData);
        setChartShow(true);
      })
      .catch((error) => {
        setIsloading(false);
        props.snackbarShowMessage(error.message, "error");
        appLogger.error({
          errObj: {
            method: "fetchRatingChartData",
            component: "dashboard",
            fileName: "index.tsx",
            err: error,
          },
        });
      });
  };
  const fetchDailyCountBugChartData = () => {
    const datewiseFilter = `&startDate=${
      startDateValue ? startDateValue : Date.parse(stDate.toString())
    }&endDate=${endDateValue ? endDateValue : Date.parse(currDate.toString())}`;

    Http.get({
      url: `/api/v2/chart/BUG_REPORT?${proVerUrl}&xAxisData=DateTime${datewiseFilter}&agent=FEEDBACK_AGENT`,
      state: userInfo,
    })
      .then((response: any) => {
        setDailyCountBugChartData(response.chartData);
        appLogger.info({
          infoObj: {
            method: "fetchDailyCountBugChartData",
            component: "dashboard",
            fileName: "index.tsx",
            dailyCount: response.chartData,
          },
        });
      })
      .catch((error) => {
        setIsloading(false);
        props.snackbarShowMessage(error.message, "error");
        appLogger.error({
          errObj: {
            method: "fetchDailyCountBugChartData",
            component: "dashboard",
            fileName: "index.tsx",
            err: error,
          },
        });
      });
  };
  const fetchDailyCountFeedbackChartData = () => {
    const datewiseFilter = `&startDate=${
      startDateValue ? startDateValue : Date.parse(stDate.toString())
    }&endDate=${endDateValue ? endDateValue : Date.parse(currDate.toString())}`;

    Http.get({
      url: `/api/v2/chart/FEEDBACK?${proVerUrl}&xAxisData=DateTime${datewiseFilter}`,
      state: userInfo,
    })
      .then((response: any) => {
        setDailyCountFeedbackChartData(response.chartData);
        appLogger.info({
          infoObj: {
            method: "fetchDailyCountFeedbackChartData",
            component: "dashboard",
            fileName: "index.tsx",
            dailyCount: response.chartData,
          },
        });
      })
      .catch((error) => {
        setIsloading(false);
        props.snackbarShowMessage(error.message, "error");
        appLogger.error({
          errObj: {
            method: "fetchDailyCountFeedbackChartData",
            component: "dashboard",
            fileName: "index.tsx",
            err: error,
          },
        });
      });
  };
  const fetchDailyCountFeatureReqChartData = () => {
    const datewiseFilter = `&startDate=${
      startDateValue ? startDateValue : Date.parse(stDate.toString())
    }&endDate=${endDateValue ? endDateValue : Date.parse(currDate.toString())}`;

    Http.get({
      url: `/api/v2/chart/FEATURE_REQUEST?${proVerUrl}&xAxisData=DateTime${datewiseFilter}`,
      state: userInfo,
    })
      .then((response: any) => {
        setDailyCountFeatureReqChartData(response.chartData);
        appLogger.info({
          infoObj: {
            method: "fetchDailyCountFeatureReqChartData",
            component: "dashboard",
            fileName: "index.tsx",
            dailyCount: response.chartData,
          },
        });
      })
      .catch((error) => {
        setIsloading(false);
        props.snackbarShowMessage(error.message, "error");
        appLogger.error({
          errObj: {
            method: "fetchDailyCountFeatureReqChartData",
            component: "dashboard",
            fileName: "index.tsx",
            err: error,
          },
        });
      });
  };
  const fetchUserCountsFBData = () => {
    if (proVerUrl) {
      const datewiseFilter =
        startDateValue && endDateValue
          ? `&startDate=${startDateValue ? startDateValue : ""}&endDate=${
              endDateValue ? endDateValue : ""
            }`
          : "";
      Http.get({
        url: `/api/v2/count/FEEDBACK?${proVerUrl}&countType=All&count=10${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          appLogger.info({
            infoObj: {
              method: "fetchUserCountsFBData",
              component: "dashboard",
              fileName: "index.tsx",
              userCountData: response,
            },
          });
          setUserCountsFBData(response);
        })
        .catch((error) => {
          setIsloading(false);
          props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "fetchUserCountsFBData",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    }
  };
  const fetchUserCountsBugsData = () => {
    if (proVerUrl) {
      const datewiseFilter =
        startDateValue && endDateValue
          ? `&startDate=${startDateValue ? startDateValue : ""}&endDate=${
              endDateValue ? endDateValue : ""
            }`
          : "";
      Http.get({
        url: `/api/v2/count/BUG_REPORT?${proVerUrl}&countType=All&count=10${datewiseFilter}&agent=FEEDBACK_AGENT`,
        state: userInfo,
      })
        .then((response: any) => {
          appLogger.info({
            infoObj: {
              method: "fetchUserCountsBugsData",
              component: "dashboard",
              fileName: "index.tsx",
              userCountData: response,
            },
          });
          setUserCountsBugsData(response);
        })
        .catch((error) => {
          setIsloading(false);
          props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "fetchUserCountsBugsData",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    }
  };
  const fetchFeatureReqChartData = () => {
    const datewiseFilter =
      startDateValue && endDateValue
        ? `&startDate=${startDateValue ? startDateValue : ""}&endDate=${
            endDateValue ? endDateValue : ""
          }`
        : "";
    Http.get({
      url: `/api/v2/chart/FEATURE_REQUEST?${proVerUrl}&xAxisData=Category${datewiseFilter}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "fetchFeatureReqChartData",
            component: "dashboard",
            fileName: "index.tsx",
            featureChartData: response.chartData,
          },
        });
        setFeatureReqChartData(response.chartData);
      })
      .catch((error) => {
        setIsloading(false);
        props.snackbarShowMessage(error.message, "error");
        appLogger.error({
          errObj: {
            method: "fetchFeatureReqChartData",
            component: "dashboard",
            fileName: "index.tsx",
            err: error,
          },
        });
      });
  };
  const fetchUserCountsFeatureReqData = () => {
    if (proVerUrl) {
      const datewiseFilter =
        startDateValue && endDateValue
          ? `&startDate=${startDateValue ? startDateValue : ""}&endDate=${
              endDateValue ? endDateValue : ""
            }`
          : "";
      Http.get({
        url: `/api/v2/count/FEATURE_REQUEST?${proVerUrl}&countType=All&count=10${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          appLogger.info({
            infoObj: {
              method: "fetchUserCountsFeatureReqData",
              component: "dashboard",
              fileName: "index.tsx",
              userCount: response,
            },
          });
          setUserCountsFeatureReqData(response);
        })
        .catch((error) => {
          setIsloading(false);
          appLogger.error({
            errObj: {
              method: "fetchUserCountsFeatureReqData",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
        });
    }
  };

  useEffect(() => {
    // if (product && version) {
    if (selectedProVerDataType == "confirm" && selectedProVerData.length > 0) {
      appLogger.info({
        infoObj: {
          method: "useEffect",
          component: "dashboard",
          fileName: "index.tsx",
          data: {
            product,
            version,
            selectedProVerData,
            selectedProVerDataType,
          },
        },
      });
      fetchRatingChartData();
      fetchBugReportChartData();
      fetchDailyCountFeedbackChartData();
      fetchDailyCountBugChartData();
      fetchDailyCountFeatureReqChartData();
      fetchUserCountsFBData();
      fetchUserCountsBugsData();
      if (enableInsights && enabledFeatures?.enableInsights) {
        fetchInsightsData();
        fetchInsightsBugData();
      }
      setIsloading(true);
      fetchUserCountsFeatureReqData();
      fetchFeatureReqChartData();
      fetchInsightsFeatureReqData();
      fetchMetricCount();
    }
  }, [product, version, selectedProVerDataType]);
  // }, [product, version]);

  // useEffect(() => {
  //   if (product && version) {
  //     if (startDateValue > endDateValue) {
  //       setEndDateValue(null);
  //     } else {
  //       if (
  //         (startDateValue && endDateValue) ||
  //         (startDateValue === null && endDateValue === null)
  //       ) {
  //         fetchRatingChartData();
  //         fetchBugReportChartData();
  //         fetchDailyCountFeedbackChartData();
  //         fetchDailyCountBugChartData();
  //         fetchDailyCountFeatureReqChartData();
  //         fetchUserCountsFBData();
  //         fetchUserCountsBugsData();
  //         if (enableInsights && enabledFeatures?.enableInsights) {
  //           fetchInsightsData();
  //           fetchInsightsBugData();
  //         }
  //         setIsloading(true);
  //         fetchUserCountsFeatureReqData();
  //         fetchFeatureReqChartData();
  //         fetchMetricCount();
  //       }
  //     }
  //   }
  // }, [startDateValue, endDateValue]);
  useEffect(() => {
    if (product && version && proVerUrl) {
      if (
        (startDateValue && endDateValue) ||
        (startDateValue === null && endDateValue === null)
      ) {
        fetchRatingChartData();
        fetchBugReportChartData();
        fetchDailyCountFeedbackChartData();
        fetchDailyCountBugChartData();
        fetchDailyCountFeatureReqChartData();
        fetchUserCountsFBData();
        fetchUserCountsBugsData();
        if (enableInsights && enabledFeatures?.enableInsights) {
          fetchInsightsData();
          fetchInsightsBugData();
        }
        setIsloading(true);
        fetchUserCountsFeatureReqData();
        fetchFeatureReqChartData();
        fetchMetricCount();
        setIsloading(true);
      }
    }
  }, [startDateValue, endDateValue]);
  const HandleProVer = (product: any, version: any) => {
    setProVersion({
      product: product,
      version: version,
    });
  };
  const selectProduct = (event: SelectChangeEvent) => {
    setProduct((event.target as HTMLInputElement).value);
    setVersion("");
    HandleProVer((event.target as HTMLInputElement).value, "");
  };
  const selectVersion = (event: SelectChangeEvent) => {
    setVersion((event.target as HTMLInputElement).value);
    HandleProVer(product, (event.target as HTMLInputElement).value);
  };
  const selectedProVerDataFn = (selectedProVerData: any, type: any) => {
    let getData = selectedProVerData;
    // if (getData.length > 0) {
    getData = selectedProVerData;
    setselectedProVerData(selectedProVerData);
    // }
    // else {
    //   getData = [
    //     {
    //       value: selectedProduct.id,
    //       title: selectedProduct.name,
    //       version: selectedProduct.version,
    //       proversion: selectedProduct.name + selectedProduct.version,
    //     },
    //   ];
    // }
    // if (type == "confirm") {
    HandleContextSelectedProVer(getData);
    // }
    setselectedProVerData(getData);
    let tempproVerUrl = "";
    getData &&
      getData.length > 0 &&
      getData.map((data: any) => {
        tempproVerUrl += `&prodId=${data.value}&prodVersion=${data.version}`;
      });
    setproVerUrl(tempproVerUrl);
    setselectedProVerDataType(selectedProVerData.type);
  };
  const HandleContextSelectedProVer = (data: any) => {
    setcontextProVersion(data);
  };
  const goToPage = (type: string) => {
    appLogger.info({
      infoObj: {
        method: "goToPage",
        component: "dashboard",
        fileName: "index.tsx",
        data: { type: type },
      },
    });
    setFilterDate({
      startDate: "",
      endDate: "",
    });
    const stateObj = {
      pageType: type,
      insight: "",
      keyName: "",
      keyWordType: "",
    };
    navigate("/feedback", { state: stateObj });
  };
  const renderLable = (keyword: any, count: any) => {
    // const val = "Home Screen";
    return (
      <>
        <span style={{ fontSize: 10 }}>{keyword}</span>
        <span className="insight-chip-count">{count}</span>
      </>
    );
  };
  const popperSx: any = {
    "& .MuiPaper-root": {
      padding: 2,
      marginLeft: -16,
    },
  };

  const filterInsight = (type: any, show: any) => {
    if (type == "Positive") {
      setPositiveInsightData(!show);
    } else if (type == "Negative") {
      setNegativeInsightData(!show);
    } else if (type == "Neutral") {
      setNeutralInsightData(!show);
    }
  };
  /* Item argument contains data for clicked chip component */
  const chipFilter = (
    i: any,
    keyWordType: any,
    item: any,
    keyName: any,
    pageType: any
  ) => {
    // item.props.children[0]
    const stateObj = {
      pageType: pageType,
      insight: i,
      keyWordType: keyWordType,
      product: product,
      version: version,
      keyName: keyName,
    };
    navigate("/feedback", { state: stateObj });
  };

  const clearDate = () => {
    setStartDateValue(stDateTimestamp);
    setEndDateValue(currDateTimestamp);
    setFilterDate({
      startDate: currDateTimestamp,
      endDate: currDateTimestamp,
    });
  };

  const setChartData = () => {};
  const [anchorEl, setAnchorEl] = React.useState<any>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [SelectedValue, setsendSelectedValue] = React.useState<any>([]);

  const sendSelectedValue = (val: any) => {
    // setsendSelectedValue(val);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const renderNoProductMessage = () => {
    let res = <></>;
    if (productResponse.length == 0 && !isLoading) {
      res = <NoProductMessage />;
    }
    return res;
  };
  // const sliderValue = (value: any) => {
  //   const res = (
  //     <>
  //       {value * 20}
  //       <Slider
  //         disabled
  //         aria-label="Temperature"
  //         defaultValue={value * 20}
  //         className="count-slidder"
  //       />
  //     </>
  //   );

  //   return res;
  // };
  // useEffect(() => {
  //   overAllscore(metricData);
  // }, [metricData]);

  const renderColor = (val: number) => {
    let colour = "";
    if (val >= 0 && val < 1) {
      colour = "#e51919";
    } else if (val >= 1 && val < 2) {
      colour = "#f97b28";
    } else if (val >= 2 && val < 3) {
      colour = "#f4c51a";
    } else if (val >= 3 && val < 4) {
      colour = "#76d43b";
    } else if (val >= 4 && val <= 5) {
      colour = "#028128";
    }
    return colour;
  };

  const overAllscore = () => {
    let label = "";
    if (metricData) {
      if (metricData.score >= 0 && metricData.score < 1) {
        label = "Critical";
      } else if (metricData.score >= 1 && metricData.score < 2) {
        label = "Needs Attention";
      } else if (metricData.score >= 2 && metricData.score < 3) {
        label = "Acceptable";
      } else if (metricData.score >= 3 && metricData.score < 4) {
        label = "Good";
      } else if (metricData.score >= 4 && metricData.score <= 5) {
        label = "Very Good";
      }
    }

    return (
      <Paper
        sx={{
          p: 2,
          maxWidth: 500,
          flexGrow: 1,
          boxShadow: "none",
          backgroundColor: (theme) => "transparent",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography
                  sx={{ fontWeight: 600, fontSize: 16 }}
                  gutterBottom
                  variant="subtitle1"
                  component="div"
                >
                  Performance Score
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: 11,
                    display: "flex",
                    color: "#20212470",
                    fontStyle: "italic",
                  }}
                >
                  How it is calculated&nbsp;
                  <Tooltip
                    title="Performance score is calculated based on weighted average including all feedback and bugs"
                    placement="top"
                  >
                    <HelpIcon
                      sx={{ mt: 0.3, fontSize: 12 }}
                      onClick={(e: any) => {
                        e.stopPropagation();
                      }}
                    />
                  </Tooltip>
                </Typography>
              </Grid>
            </Grid>
            {metricData && metricData.score > 0 && (
              <Grid item>
                <Typography variant="subtitle1" component="div">
                  <span
                    className="overallscore-total"
                    style={{
                      color: renderColor(metricData ? metricData.score : 0),
                    }}
                  >
                    {metricData
                      ? metricData.score % 1 != 0
                        ? metricData.score.toFixed(1)
                        : metricData.score
                      : 0}
                  </span>
                  <span className="overallscore-outof">&nbsp;of 5</span>
                </Typography>
                <Typography variant="subtitle1" component="div">
                  <span className="overallscore-remark">({label})</span>
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
        {metricData && metricData.score > 0 && (
          <Slider
            disabled
            aria-label="Performance Score"
            value={metricData ? metricData.score : 0}
            className="count-slidder"
            min={0}
            max={5}
          />
        )}
      </Paper>
    );
  };

  const displayMostAreaScore = (categoryScoreIndex: number) => {
    return metricData &&
      metricData.feedbackCategoryData &&
      Object.values(metricData.feedbackCategoryData)[categoryScoreIndex][
        "score"
      ] >= 3 ? (
      displayAreaAndScore(categoryScoreIndex)
    ) : (
      <span></span>
    );
  };

  const displayLeastAreaScore = (categoryScoreIndex: number) => {
    return metricData &&
      metricData.feedbackCategoryData &&
      Object.values(metricData.feedbackCategoryData)[categoryScoreIndex][
        "score"
      ] < 3 ? (
      displayAreaAndScore(categoryScoreIndex)
    ) : (
      <span></span>
    );
  };

  const displayAreaAndScore = (categoryScoreIndex: number) => {
    const score: number =
      metricData && metricData.feedbackCategoryData
        ? Object.values(metricData.feedbackCategoryData)[categoryScoreIndex][
            "score"
          ]
        : 0;
    const colorVal: string = renderColor(score);
    return (
      <Typography
        variant="body1"
        sx={{ fontSize: 11 }}
        style={{
          display: "flex",
          alignItems: "baseline",
          color: "#20212470",
        }}
      >
        <span style={{ fontSize: "12px", color: "#000000b5" }}>
          {metricData &&
            metricData.feedbackCategoryData &&
            Object.keys(metricData.feedbackCategoryData)[
              categoryScoreIndex
            ]}{" "}
          : &nbsp;
        </span>
        <span className="test" style={{ color: `${colorVal}` }}>
          {" "}
          {score % 1 != 0 ? score.toFixed(1) : score}
          &nbsp;
        </span>
        <span style={{ fontSize: "12px", color: "#000000b5" }}>
          &nbsp;of 5{" "}
        </span>
        <Slider
          disabled
          aria-label="Performance Score"
          value={score}
          className="count-slidder-small"
          min={0}
          max={5}
        />
      </Typography>
    );
  };

  const mostScore = () => {
    return (
      <Paper
        sx={{
          p: 2,
          maxWidth: 500,
          flexGrow: 1,
          boxShadow: "none",
          backgroundColor: (theme) => "transparent",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography
                  sx={{ fontWeight: 600, fontSize: 16 }}
                  gutterBottom
                  variant="subtitle1"
                  component="div"
                >
                  Areas of good performance:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: 11,
                    display: "flex",
                    color: "#20212470",
                    fontStyle: "italic",
                  }}
                >
                  Performance score of 3 or more.
                </Typography>
                {metricData &&
                metricData.feedbackCategoryData &&
                Object.keys(metricData.feedbackCategoryData).length >= 1 ? (
                  displayMostAreaScore(
                    Object.keys(metricData.feedbackCategoryData).length - 1
                  )
                ) : (
                  <div></div>
                )}
                {metricData &&
                metricData.feedbackCategoryData &&
                Object.keys(metricData.feedbackCategoryData).length >= 2 ? (
                  displayMostAreaScore(
                    Object.keys(metricData.feedbackCategoryData).length - 2
                  )
                ) : (
                  <div></div>
                )}
                {metricData &&
                metricData.feedbackCategoryData &&
                Object.keys(metricData.feedbackCategoryData).length >= 3 ? (
                  displayMostAreaScore(
                    Object.keys(metricData.feedbackCategoryData).length - 3
                  )
                ) : (
                  <div></div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  };
  const leastScore = () => {
    return (
      <Paper
        sx={{
          p: 2,
          maxWidth: 500,
          flexGrow: 1,
          boxShadow: "none",
          backgroundColor: (theme) => "transparent",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography
                  sx={{ fontWeight: 600, fontSize: 16 }}
                  gutterBottom
                  variant="subtitle1"
                  component="div"
                >
                  Areas that need attention:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: 11,
                    display: "flex",
                    color: "#20212470",
                    fontStyle: "italic",
                  }}
                >
                  Performance score of less than 3.
                </Typography>
                {metricData &&
                metricData.feedbackCategoryData &&
                Object.keys(metricData.feedbackCategoryData).length >= 1 ? (
                  displayLeastAreaScore(0)
                ) : (
                  <div></div>
                )}
                {metricData &&
                metricData.feedbackCategoryData &&
                Object.keys(metricData.feedbackCategoryData).length >= 2 ? (
                  displayLeastAreaScore(1)
                ) : (
                  <div></div>
                )}
                {metricData &&
                metricData.feedbackCategoryData &&
                Object.keys(metricData.feedbackCategoryData).length >= 3 ? (
                  displayLeastAreaScore(2)
                ) : (
                  <div></div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  };
  const minDateTime = new Date();
  minDateTime.setHours(17);
  const maxDateTime = new Date();
  maxDateTime.setHours(20);

  const renderGuidedSteps: any = () => {
    const steps: any = [
      // {
      //   disableBeacon: true,
      //   disableOverlayClose: true,
      //   hideCloseButton: true,
      //   hideFooter: true,
      //   placement: "right",
      //   spotlightClicks: true,
      //   styles: {
      //     options: {
      //       zIndex: 10000,
      //     },
      //   },
      //   target: ".products-menu-side",
      //   content: (
      //     <div>
      //       <h3 className="guidesteptitle">Create a product</h3>
      //       <h4 className="guidestepsubtitle">
      //         Step 1: Enter the name for your product.
      //       </h4>
      //       <br />
      //     </div>
      //   ),
      // },
      {
        disableBeacon: true,
        hideFooter: true,
        placement: "right",
        spotlightClicks: true,
        styles: {
          options: {
            zIndex: 10000,
          },
        },
        target: ".configuration-menu-side",
        content: (
          <div>
            <h3 className="guidesteptitle">Configure a account</h3>
            <h4 className="guidestepsubtitle" style={{ marginBottom: "7px" }}>
              Please go to manage accounts to configure your accounts
            </h4>
          </div>
        ),
      },
    ];
    return steps;
  };
  useEffect(() => {
    if (productResponse.length == 0 && !isLoading) {
      setRun(!run);
    }
  }, [productResponse, isLoading]);
  // const openGuidedtour = () => {
  //   if (productResponse.length == 0 && !isLoading) {
  //     setRun(!run);
  //   }
  // };
  const handleJoyrideCallback = (data: any) => {
    const { action, index, status, type } = data;
    if (
      status == STATUS.FINISHED ||
      action == ACTIONS.CLOSE ||
      action == ACTIONS.SKIP
    ) {
      setRun(false);
    }
  };
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  // console.log(JSON.parse(userEnabledFeatures), "userEnabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  return (
    <Grid className={isLoading ? " chart-item loader" : "chart-item"}>
      {/* {renderNoProductMessage()} */}
      <Grid className="feedback-bug-filter" container sx={{ mb: 2 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={4}
          xl={4}
          className="pro-ver-dropdown-grid"
        >
          <ProductVersionDropdown
            productResponse={productResponse}
            selectedProVerData={selectedProVerData}
            selectedProVerDataFn={selectedProVerDataFn}
            contextProVersion={contextProVersion}
            type="cuvo-dashboard"
          />
          {/* <ProductVersionDropdown sendSelectedValue={sendSelectedValue} /> */}
        </Grid>
        <Grid className="article-startdate" item xs={5} sm={4} md={4} lg={1.5}>
          <Box>
            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                label="Start Date"
                value={startDateValue}
                onChange={(newValue: any) => {
                  changeStartDateValue(newValue);
                }}
                ampm={false}
                components={{
                  OpenPickerIcon: UnfoldMore,
                }}
                renderInput={(params: any) => (
                  <>
                    <TextField
                      fullWidth
                      className="date-picker custom-select"
                      {...params}
                    />
                  </>
                )}
                maxDate={new Date()}
                minDate={addYears(new Date(), -5)}
              />
            </LocalizationProvider> */}

            <TextField
              className="date-picker custom-select"
              id="datetime-local-start"
              label="Start Date"
              type="date"
              value={startDateValue ? getDateString(startDateValue) : ""}
              onChange={changeStartDateValue}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                max: currDate.toISOString().slice(0, 10),
              }}
            />
          </Box>
        </Grid>
        &nbsp;
        <Grid item xs={5} sm={4} md={4} lg={1.5}>
          <Box>
            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                label="End Date"
                value={endDateValue}
                onChange={(newValue: any) => {
                  changeEndDateValue(newValue);
                }}
                ampm={false}
                components={{
                  OpenPickerIcon: UnfoldMore,
                  // LeftArrowIcon: SearchIcon,
                  // RightArrowIcon: SearchIcon,
                  // SwitchViewIcon: SearchIcon,
                }}
                renderInput={(params: any) => (
                  <TextField
                    fullWidth
                    className="date-picker custom-select"
                    {...params}
                  />
                )}
                minDate={
                  startDateValue
                    ? getUTCDate(startDateValue)
                    : addYears(new Date(), -5)
                }
                maxDate={new Date()}
                PopperProps={{
                  sx: popperSx,
                }}
              />
            </LocalizationProvider> */}

            <TextField
              className="date-picker custom-select"
              id="datetime-local-end"
              label="End Date"
              type="date"
              value={endDateValue ? getDateString(endDateValue) : ""}
              onChange={changeEndDateValue}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                min: getDateString(startDateValue),
                max: currDate.toISOString().slice(0, 10),
              }}
            />
          </Box>
        </Grid>
        <Grid
          item
          xs={5}
          sm={4}
          md={3}
          lg={2.3}
          className="clear-option"
          title="Reset Date"
        >
          {startDateValue || endDateValue ? (
            <ReplayIcon onClick={clearDate} />
          ) : (
            <ReplayIcon />
          )}
        </Grid>
      </Grid>
      {enableFeedback && userEnabledFeatures?.enableFeedback && metricData ? (
        <Grid className="feedback-bug-filter " container spacing={2}>
          <Grid item xs={12} lg={12}>
            <Paper
              className="count-grid-tile"
              sx={{
                margin: "auto",
                maxWidth: 2000,
                flexGrow: 1,
                // background: "rgb(255,245,224)",
                background:
                  "linear-gradient(65deg, rgb(255 245 224 / 51%) 50%,rgb(255 245 224 / 51%) 60%)",
                // backgroundColour:
                //   "linear-gradient(toright, #c6ffdd, #fbd786, #f7797d)",
                // backgroundColor: (theme) =>
                //   theme.palette.mode === "dark" ? "#1A2027" : "#F5F7FA",
              }}
            >
              {/* *****************New  ui******************************* */}
              <Grid container>
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  lg={4}
                  className="score-card-grid"
                >
                  {overAllscore()}
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  lg={4}
                  className="score-card-grid"
                >
                  {" "}
                  {mostScore()}
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  lg={4}
                  className="score-card-grid"
                >
                  {" "}
                  {leastScore()}
                </Grid>
              </Grid>
              {/* ****************New ui******************************* */}
            </Paper>
          </Grid>
        </Grid>
      ) : null}

      {/* ****************** */}

      {/********** Count Grid Tile***************/}
      <CountGridTile
        bugReportChartData={bugReportChartData}
        ratingChartData={ratingChartData}
        UserCountsBugsData={UserCountsBugsData}
        UserCountsFBData={UserCountsFBData}
        UserCountsFeatureReqData={UserCountsFeatureReqData}
        FeatureReqChartData={FeatureReqChartData}
      />
      {/********** Count Grid Tile***************/}

      {/********** Charts ***************/}

      <Grid className="chart-wrap dash-chart" container spacing={2}>
        {enableFeedback && userEnabledFeatures?.enableFeedback && (
          <Grid item xs={12} lg={6}>
            <Box className="chart-item">
              <h2 className="title">
                Feedback
                <span>
                  Count : &nbsp;
                  {ratingChartData
                    ? ratingChartData.total
                      ? ratingChartData.total
                      : 0
                    : 0}
                </span>
              </h2>

              {ratingChartData && ratingChartData.total > 0 && (
                <Box className="avg-rating">
                  <Rating
                    className="ratings"
                    name="read-only"
                    value={
                      ratingChartData
                        ? ratingChartData.avg
                          ? ratingChartData.avg
                          : 0
                        : 0
                    }
                    readOnly
                  />
                  <Typography>
                    {ratingChartData
                      ? ratingChartData.avg
                        ? ratingChartData.avg
                        : 0
                      : 0}{" "}
                    of 5 <span>(Average rating)</span>
                  </Typography>
                </Box>
              )}
              <RatingChart
                ratingChartData={ratingChartData}
                setChartData={setChartData}
                chartShow={chartShow}
              />
              <Typography
                sx={{ p: 1 }}
                id="view-all-feedback"
                className="dash-chart-viewall"
                align="center"
                onClick={() => goToPage("FEEDBACK")}
              >
                View All <KeyboardDoubleArrowRightIcon />
              </Typography>
            </Box>
          </Grid>
        )}
        {((enableBugReport && userEnabledFeatures?.enableBugReport) ||
          (enableChatbot && userEnabledFeatures?.enableChatbot)) && (
          <Grid item xs={12} lg={6}>
            <Box className="chart-item">
              <h2 className="title">
                Ticket Reports
                <span>
                  Count : &nbsp;
                  {bugReportChartData
                    ? bugReportChartData.total
                      ? bugReportChartData.total
                      : 0
                    : 0}
                </span>
              </h2>
              <DashBugReportchart
                bugReportChartData={bugReportChartData}
                setChartData={""}
                chartShow={chartShow}
                filter=""
                selected=""
              />
              <Typography
                sx={{ p: 1 }}
                id="view-all-bug"
                className="dash-chart-viewall"
                align="center"
                onClick={() => goToPage("BUG_REPORT")}
              >
                View All <KeyboardDoubleArrowRightIcon />
              </Typography>
            </Box>
          </Grid>
        )}
        <Grid item xs={12} lg={6}>
          <Box className="chart-item daily-chart">
            <h2 className="title">Daily count</h2>
            <DailyCountchart
              dailyCountBugChartData={dailyCountBugChartData}
              dailyCountFeedbackChartData={dailyCountFeedbackChartData}
              dailyCountFeatureReqChartData={dailyCountFeatureReqChartData}
            />
            <Typography
              sx={{ p: 1 }}
              id="view-all-feedback"
              className="dash-chart-viewall"
              align="center"
              onClick={() => goToPage("FEEDBACK")}
            >
              View All <KeyboardDoubleArrowRightIcon />
            </Typography>
          </Box>
        </Grid>

        {/********** Charts ***************/}

        {/* Top 10 Commentors */}
        {enableFeedback && userEnabledFeatures?.enableFeedback && (
          <Grid item xs={12} lg={6}>
            <Box className="chart-item daily-chart">
              <h6 className="title chart-title">
                Top 10 Commenters For Feedback
              </h6>
              <TopTenChartCommentors
                // dailyCountBugChartData={dailyCountBugChartData}
                UserCountsFBData={UserCountsFBData}
                chartType="feedback"
              />
              <Typography
                sx={{ p: 1 }}
                id="view-all-feedback"
                className="dash-chart-viewall"
                align="center"
                onClick={() => goToPage("FEEDBACK")}
              >
                View All <KeyboardDoubleArrowRightIcon />
              </Typography>
            </Box>
          </Grid>
        )}
        {((enableBugReport && userEnabledFeatures?.enableBugReport) ||
          (enableChatbot && userEnabledFeatures?.enableChatbot)) && (
          <Grid item xs={12} lg={6}>
            <Box className="chart-item daily-chart">
              <h2 className="title chart-title">
                Top 10 Commenters For Tickets
              </h2>
              <TopTenChartCommentors
                // dailyCountBugChartData={dailyCountBugChartData}
                UserCountsFBData={UserCountsBugsData}
                chartType="bug"
              />
              <Typography
                sx={{ p: 1 }}
                id="view-all-feedback"
                className="dash-chart-viewall"
                align="center"
                onClick={() => goToPage("BUG_REPORT")}
              >
                View All <KeyboardDoubleArrowRightIcon />
              </Typography>
            </Box>
          </Grid>
        )}
        {enableFeatureRequest && userEnabledFeatures?.enableFeatureRequest && (
          <Grid item xs={12} lg={6}>
            <Box className="chart-item daily-chart">
              <h2 className="title chart-title">
                Top 10 Commenters For Feature Request
              </h2>
              <TopTenChartCommentors
                // dailyCountBugChartData={dailyCountBugChartData}
                UserCountsFBData={UserCountsFeatureReqData}
                chartType="featureRequest"
              />
              <Typography
                sx={{ p: 1 }}
                id="view-all-feedback"
                className="dash-chart-viewall"
                align="center"
                onClick={() => goToPage("FEATURE_REQUEST")}
              >
                View All <KeyboardDoubleArrowRightIcon />
              </Typography>
            </Box>
          </Grid>
        )}
        {/* Top 10 Commentors */}

        {/********** Insights ***************/}
        {enableInsights && enabledFeatures?.enableInsights ? (
          <Grid
            className="dash-insight-card-root"
            item
            container
            xs={12}
            lg={12}
          >
            <Grid className="dash-insight-grid-item" item xs={12} lg={12}>
              <Box className="insight-title-wrap">
                <h2 className="title">Insights</h2>
                <Box>
                  <ul className="horizontal-list">
                    <li
                      onClick={() =>
                        filterInsight("Positive", PositiveInsightData)
                      }
                    >
                      <ThumbUpAltTwoToneIcon
                        style={{
                          color: `${PositiveInsightData && "#038229"}`,
                        }}
                      />
                      <span>Positive </span>
                    </li>
                    <li
                      className="neutral-thumb-icon"
                      onClick={() =>
                        filterInsight("Neutral", NeutralInsightData)
                      }
                    >
                      <ThumbDownAltTwoToneIcon
                        style={{
                          color: `${NeutralInsightData && "#8f9ae9"}`,
                        }}
                      />
                      <span>Neutral </span>
                    </li>
                    <li
                      onClick={() =>
                        filterInsight("Negative", NegativeInsightData)
                      }
                    >
                      <ThumbDownAltTwoToneIcon
                        style={{
                          color: `${NegativeInsightData && "#f00"}`,
                        }}
                      />
                      <span>Negative </span>
                    </li>
                  </ul>

                  {!PositiveInsightData &&
                    !NegativeInsightData &&
                    !NeutralInsightData && (
                      <Typography className="no-insights">
                        (Select atleast one sentiment)
                      </Typography>
                    )}
                </Box>
              </Box>
              <Divider sx={{ my: 1 }} />
              <Grid container spacing={2} className="insight-grids">
                <Grid item xs={4}>
                  <Box className="insight-item">
                    <h2 className="title-sm">Feedback</h2>
                    <Stack
                      direction="row"
                      sx={{
                        flexWrap: "wrap",
                      }}
                      className="insight-chip-wrap"
                    >
                      {insightsData &&
                        insightsData.data &&
                        insightsData.data.NEUTRAL &&
                        Object.keys(insightsData.data.NEUTRAL).length == 0 &&
                        insightsData.data &&
                        insightsData.data.NEGATIVE &&
                        Object.keys(insightsData.data.NEGATIVE).length == 0 &&
                        insightsData.data &&
                        insightsData.data.POSITIVE &&
                        Object.keys(insightsData.data.POSITIVE).length == 0 && (
                          <Typography className="no-data">No data</Typography>
                        )}

                      {PositiveInsightData &&
                        insightsData &&
                        insightsData.data &&
                        insightsData.data.POSITIVE &&
                        Object.keys(insightsData.data.POSITIVE)
                          .slice(0, 5)
                          .map((keyName: any, i) => (
                            <Chip
                              size="small"
                              key={i}
                              variant="outlined"
                              className="chipps"
                              onClick={() =>
                                chipFilter(
                                  i,
                                  "POSITIVE",
                                  renderLable(
                                    keyName,
                                    insightsData.data.POSITIVE[keyName]
                                  ),
                                  keyName,
                                  FEEDBACK_TYPE_FEEDBACK
                                )
                              }
                              label={
                                <>
                                  {renderLable(
                                    keyName,
                                    insightsData.data.POSITIVE[keyName]
                                  )}
                                  <ThumbUpAltTwoToneIcon
                                    style={{
                                      marginLeft: 4,
                                      color: "#038229",
                                    }}
                                  />
                                </>
                              }
                            />
                          ))}
                      {NeutralInsightData &&
                        insightsData &&
                        insightsData.data &&
                        insightsData.data.NEUTRAL &&
                        Object.keys(insightsData.data.NEUTRAL)
                          .slice(0, 5)
                          .map((keyName: any, i) => (
                            <Chip
                              size="small"
                              key={i}
                              variant="outlined"
                              className="chipps neutral-thumb-icon"
                              onClick={() =>
                                chipFilter(
                                  i,
                                  "NEUTRAL",
                                  renderLable(
                                    keyName,
                                    insightsData.data.NEUTRAL[keyName]
                                  ),
                                  keyName,
                                  FEEDBACK_TYPE_FEEDBACK
                                )
                              }
                              label={
                                <>
                                  {renderLable(
                                    keyName,
                                    insightsData.data.NEUTRAL[keyName]
                                  )}
                                  <ThumbDownAltTwoToneIcon
                                    style={{
                                      marginLeft: 4,
                                      color: "#5e6fed",
                                    }}
                                  />
                                </>
                              }
                            />
                          ))}
                      {NegativeInsightData &&
                        insightsData &&
                        insightsData.data &&
                        insightsData.data.NEGATIVE &&
                        Object.keys(insightsData.data.NEGATIVE)
                          .slice(0, 5)
                          .map((keyName: any, i) => (
                            <Chip
                              size="small"
                              key={i}
                              variant="outlined"
                              className="chipps"
                              onClick={() =>
                                chipFilter(
                                  i,
                                  "NEGATIVE",
                                  renderLable(
                                    keyName,
                                    insightsData.data.NEGATIVE[keyName]
                                  ),
                                  keyName,
                                  FEEDBACK_TYPE_FEEDBACK
                                )
                              }
                              label={
                                <>
                                  {renderLable(
                                    keyName,
                                    insightsData.data.NEGATIVE[keyName]
                                  )}
                                  <ThumbDownAltTwoToneIcon
                                    style={{
                                      marginLeft: 4,
                                      color: "#f00",
                                    }}
                                  />
                                </>
                              }
                            />
                          ))}
                    </Stack>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box className="insight-item">
                    <h2 className="title-sm">Bugs</h2>
                    <Stack
                      direction="row"
                      sx={{
                        flexWrap: "wrap",
                      }}
                      className="insight-chip-wrap"
                    >
                      {insightsBugData &&
                        insightsBugData.data &&
                        insightsBugData.data.NEUTRAL &&
                        Object.keys(insightsBugData.data.NEUTRAL).length == 0 &&
                        insightsBugData.data &&
                        insightsBugData.data.NEGATIVE &&
                        Object.keys(insightsBugData.data.NEGATIVE).length ==
                          0 &&
                        insightsBugData.data &&
                        insightsBugData.data.POSITIVE &&
                        Object.keys(insightsBugData.data.POSITIVE).length ==
                          0 && (
                          <Typography className="no-data">No data</Typography>
                        )}

                      {PositiveInsightData &&
                        insightsBugData &&
                        insightsBugData.data &&
                        insightsBugData.data.POSITIVE &&
                        Object.keys(insightsBugData.data.POSITIVE)
                          .slice(0, 5)
                          .map((keyName: any, i) => (
                            <Chip
                              size="small"
                              key={i}
                              variant="outlined"
                              className="chipps"
                              onClick={() =>
                                chipFilter(
                                  i,
                                  "POSITIVE",
                                  renderLable(
                                    keyName,
                                    insightsBugData.data.POSITIVE[keyName]
                                  ),
                                  keyName,
                                  FEEDBACK_TYPE_BUG_REPORT
                                )
                              }
                              label={
                                <>
                                  {renderLable(
                                    keyName,
                                    insightsBugData.data.POSITIVE[keyName]
                                  )}
                                  <ThumbUpAltTwoToneIcon
                                    style={{
                                      marginLeft: 4,
                                      color: "#038229",
                                    }}
                                  />
                                </>
                              }
                            />
                          ))}

                      {NeutralInsightData &&
                        insightsBugData &&
                        insightsBugData.data &&
                        insightsBugData.data.NEUTRAL &&
                        Object.keys(insightsBugData.data.NEUTRAL)
                          .slice(0, 5)
                          .map((keyName: any, i) => (
                            <Chip
                              size="small"
                              key={i}
                              variant="outlined"
                              className="chipps neutral-thumb-icon"
                              onClick={() =>
                                chipFilter(
                                  i,
                                  "NEUTRAL",
                                  renderLable(
                                    keyName,
                                    insightsData.data.NEUTRAL[keyName]
                                  ),
                                  keyName,
                                  FEEDBACK_TYPE_BUG_REPORT
                                )
                              }
                              label={
                                <>
                                  {renderLable(
                                    keyName,
                                    insightsBugData.data.NEUTRAL[keyName]
                                  )}
                                  <ThumbDownAltTwoToneIcon
                                    style={{
                                      marginLeft: 4,
                                      color: "#5e6fed",
                                    }}
                                  />
                                </>
                              }
                            />
                          ))}

                      {NegativeInsightData &&
                        insightsBugData &&
                        insightsBugData.data &&
                        insightsBugData.data.NEGATIVE &&
                        Object.keys(insightsBugData.data.NEGATIVE)
                          .slice(0, 5)
                          .map((keyName: any, i) => (
                            <Chip
                              size="small"
                              key={i}
                              variant="outlined"
                              className="chipps"
                              onClick={() =>
                                chipFilter(
                                  i,
                                  "NEGATIVE",
                                  renderLable(
                                    keyName,
                                    insightsBugData.data.NEGATIVE[keyName]
                                  ),
                                  keyName,
                                  FEEDBACK_TYPE_BUG_REPORT
                                )
                              }
                              label={
                                <>
                                  {renderLable(
                                    keyName,
                                    insightsBugData.data.NEGATIVE[keyName]
                                  )}
                                  <ThumbDownAltTwoToneIcon
                                    style={{
                                      marginLeft: 4,
                                      color: "#f00",
                                    }}
                                  />
                                </>
                              }
                            />
                          ))}
                    </Stack>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box className="insight-item">
                    <h2 className="title-sm"> Feature Request</h2>{" "}
                    <Stack
                      direction="row"
                      sx={{
                        flexWrap: "wrap",
                      }}
                      className="insight-chip-wrap"
                    >
                      {insightsFeatureReqData &&
                        insightsFeatureReqData.data &&
                        insightsFeatureReqData.data.NEUTRAL &&
                        Object.keys(insightsFeatureReqData.data.NEUTRAL)
                          .length == 0 &&
                        insightsFeatureReqData.data &&
                        insightsFeatureReqData.data.NEGATIVE &&
                        Object.keys(insightsFeatureReqData.data.NEGATIVE)
                          .length == 0 &&
                        insightsFeatureReqData.data &&
                        insightsFeatureReqData.data.POSITIVE &&
                        Object.keys(insightsFeatureReqData.data.POSITIVE)
                          .length == 0 && (
                          <Typography className="no-data">No data</Typography>
                        )}

                      {PositiveInsightData &&
                        insightsFeatureReqData &&
                        insightsFeatureReqData.data &&
                        insightsFeatureReqData.data.POSITIVE &&
                        Object.keys(insightsFeatureReqData.data.POSITIVE)
                          .slice(0, 5)
                          .map((keyName: any, i) => (
                            <Chip
                              size="small"
                              key={i}
                              variant="outlined"
                              className="chipps"
                              onClick={() =>
                                chipFilter(
                                  i,
                                  "POSITIVE",
                                  renderLable(
                                    keyName,
                                    insightsFeatureReqData.data.POSITIVE[
                                      keyName
                                    ]
                                  ),
                                  keyName,
                                  FEEDBACK_TYPE_FEATURE_REQ
                                )
                              }
                              label={
                                <>
                                  {renderLable(
                                    keyName,
                                    insightsFeatureReqData.data.POSITIVE[
                                      keyName
                                    ]
                                  )}
                                  <ThumbUpAltTwoToneIcon
                                    style={{
                                      marginLeft: 4,
                                      color: "#038229",
                                    }}
                                  />
                                </>
                              }
                            />
                          ))}
                      {NeutralInsightData &&
                        insightsFeatureReqData &&
                        insightsFeatureReqData.data &&
                        insightsFeatureReqData.data.NEUTRAL &&
                        Object.keys(insightsFeatureReqData.data.NEUTRAL)
                          .slice(0, 5)
                          .map((keyName: any, i) => (
                            <Chip
                              size="small"
                              key={i}
                              variant="outlined"
                              className="chipps neutral-thumb-icon"
                              onClick={() =>
                                chipFilter(
                                  i,
                                  "NEUTRAL",
                                  renderLable(
                                    keyName,
                                    insightsFeatureReqData.data.NEUTRAL[keyName]
                                  ),
                                  keyName,
                                  FEEDBACK_TYPE_FEATURE_REQ
                                )
                              }
                              label={
                                <>
                                  {renderLable(
                                    keyName,
                                    insightsFeatureReqData.data.NEUTRAL[keyName]
                                  )}
                                  <ThumbDownAltTwoToneIcon
                                    style={{
                                      marginLeft: 4,
                                      color: "#5e6fed",
                                    }}
                                  />
                                </>
                              }
                            />
                          ))}
                      {NegativeInsightData &&
                        insightsFeatureReqData &&
                        insightsFeatureReqData.data &&
                        insightsFeatureReqData.data.NEGATIVE &&
                        Object.keys(insightsFeatureReqData.data.NEGATIVE)
                          .slice(0, 5)
                          .map((keyName: any, i) => (
                            <Chip
                              size="small"
                              key={i}
                              variant="outlined"
                              className="chipps"
                              onClick={() =>
                                chipFilter(
                                  i,
                                  "NEGATIVE",
                                  renderLable(
                                    keyName,
                                    insightsFeatureReqData.data.NEGATIVE[
                                      keyName
                                    ]
                                  ),
                                  keyName,
                                  FEEDBACK_TYPE_FEATURE_REQ
                                )
                              }
                              label={
                                <>
                                  {renderLable(
                                    keyName,
                                    insightsFeatureReqData.data.NEGATIVE[
                                      keyName
                                    ]
                                  )}
                                  <ThumbDownAltTwoToneIcon
                                    style={{
                                      marginLeft: 4,
                                      color: "#f00",
                                    }}
                                  />
                                </>
                              }
                            />
                          ))}
                    </Stack>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <></>
        )}
        <Joyride
          locale={{
            open: "Click to see the steps",
          }}
          run={run}
          callback={handleJoyrideCallback}
          disableScrolling
          styles={{
            options: {
              // modal arrow and background color
              arrowColor: "#0157ff",
              backgroundColor: "#0157ff",
              // page overlay color
              overlayColor: "#4f4f4f",
              //button color
              primaryColor: "#d68520",
              //text color
              textColor: "#fff",

              //width of modal
              width: 300,
              //zindex of modal
              zIndex: 1000,
            },
          }}
          continuous
          showProgress
          showSkipButton
          steps={renderGuidedSteps()}
        />
        {/********** Insights ***************/}
      </Grid>
    </Grid>
  );
}
export default withSnackbar(DashboardContent);
